import { format } from "date-fns";
import { ptBR } from "date-fns/locale";
import type { IAuditoriaAcaoItem, IAuditoriaEventoGrupo } from "@/api/space/dtos/authenticator.dto";
import type { AppBadgeTom } from "@/components/ui/appBadge";
import { parseDataHoraUTC } from "@/utils/validators/date";
import type { FiltroTipoAuditoria } from "../../../cadastroRestricoes.types";
import { AUDITORIA_TIPO_LABELS } from "./auditoria.constants";

// ---------------------------------------------------- ESTILOS / MAPAS ------------------------------------------------
export const COLOR_ACAO: Record<IAuditoriaAcaoItem, AppBadgeTom> = {
	inserido: "info",
	ativado: "success",
	desativado: "danger",
	inalterado: "muted",
};

export const ICONE_ACAO: Record<IAuditoriaAcaoItem, string> = {
	inserido: "lucide:plus",
	ativado: "lucide:check",
	desativado: "lucide:x",
	inalterado: "lucide:minus",
};

export const OPCOES_TIPO: Array<{ value: FiltroTipoAuditoria; label: string }> = [
	{ value: "todos", label: "Todos" },
	{ value: "salvar_acessos_grupo_usuario", label: AUDITORIA_TIPO_LABELS.salvar_acessos_grupo_usuario },
	{ value: "clonar_grupo_usuario", label: AUDITORIA_TIPO_LABELS.clonar_grupo_usuario },
];

export function rotuloContagem(n: number, singular: string, plural: string): string {
	return `${n} ${n === 1 ? singular : plural}`;
}

// ---------------------------------------------------- DATA / AGRUPAMENTO ---------------------------------------------
/** Resolve o timestamp `*_utc` reusando o parser central; fallback defensivo se vier malformado. */
const resolverData = (iso: string): Date => parseDataHoraUTC(iso) ?? new Date(iso);

export const formatarHoraAuditoria = (iso: string): string => format(resolverData(iso), "HH:mm");

export const formatarDiaAuditoria = (iso: string): string =>
	format(resolverData(iso), "dd 'de' MMMM 'de' yyyy", { locale: ptBR });

export type GrupoDiaAuditoria = {
	chave: string;
	rotulo: string;
	eventos: IAuditoriaEventoGrupo[];
};

/** Agrupa eventos por dia preservando a ordem recebida (o backend devolve do mais recente para o mais antigo). */
export function agruparAuditoriaPorDia(eventos: IAuditoriaEventoGrupo[]): GrupoDiaAuditoria[] {
	const grupos: GrupoDiaAuditoria[] = [];
	const indicePorChave = new Map<string, number>();

	for (const evento of eventos) {
		const data = resolverData(evento.data_hora_utc);
		const chave = `${data.getFullYear()}-${data.getMonth()}-${data.getDate()}`;
		const indice = indicePorChave.get(chave);

		if (indice === undefined) {
			indicePorChave.set(chave, grupos.length);
			grupos.push({ chave, rotulo: formatarDiaAuditoria(evento.data_hora_utc), eventos: [evento] });
		} else grupos[indice].eventos.push(evento);
	}

	return grupos;
}
